import {AsyncCacheMap} from "@app/common/helpers/async-cache-map/async-cache-map"
import {DataObject} from "@cm/utils/data-object"
import {from, Observable} from "rxjs"

export class DataObjectSizeCache extends AsyncCacheMap<string, number | null, DataObject> {
    constructor() {
        super((_, dataObject: DataObject) => {
            const loadImageBuffer = async (dataObject: DataObject): Promise<number | null> => {
                const response = await fetch(dataObject.downloadUrl, {method: "HEAD"})
                if (!response.ok) throw new Error("HEAD request failed")

                const size = response.headers.get("Content-Length")
                return size ? Number(size) : null
            }

            return from(loadImageBuffer(dataObject))
        })
    }

    evaluateDataObjectSize(dataObject: DataObject): Observable<number | null> {
        return this.get(dataObject.downloadUrl, dataObject)
    }
}
